import React from "react";
import BaseCom from "../BaseCom";
import * as monaco from 'monaco-editor';

export default class CodeEditor extends BaseCom {
    
    constructor(props) {
        super(props);
        this.state = {};
        this.editorRef = React.createRef();
    }

    componentDidMount() {
        this.editor = monaco.editor.create(this.editorRef.current, {
            value: this.props.value,
            language: this.props.language || 'csharp',
            automaticLayout: true,
        });
        this.editor.onDidChangeModelContent( (event) => {
            let content = this.editor.getValue();
            this.props.onChange?.(content);
        });
        monaco.languages.registerCompletionItemProvider('json', {
            provideCompletionItems: function (model, position) {
                var word = model.getWordAtPosition(position);
                var suggestions = [
                    {
                        label: 'Console',
                        kind: monaco.languages.CompletionItemKind.Function,
                        insertText: 'Console'
                    },
                    {
                        label: 'WriteLine',
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: 'WriteLine()',
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet
                    },
                    {
                        label: 'using',
                        kind: monaco.languages.CompletionItemKind.Keyword,
                        insertText: 'using '
                    }
                ];
                return { suggestions: suggestions };
            }
        });
        monaco.editor.defineTheme('custom', {
            base: 'vs',
            inherit: true,
            rules: [

            ],
            colors: {
              'editor.background': '#ffffff',
            }
          });
          monaco.editor.setTheme('custom');
    }
    
    componentDidUpdate(prevProps) {
        if(this.props.hash !== prevProps.hash) {
            this.editor.setValue(this.props.value);
        }
    }

    render() {
        return (
            <div ref={this.editorRef} style={{ height: this.props.height || '50vh' }}></div>
        );
    }
}